//
//
//
//
//
//
//
//
//

export default {
  name: "cSvg",
  props: {
    src: { 
      type: String, 
      required: true 
    },
    fill: { 
      type: String, 
      default: "" 
    },
    // 🎯 默认值保持 '100%'。不传参时，自动作为字符串输出，直接占满当前父格子
    width: { 
      type: [Number, String], 
      default: '100%' 
    },
    height: { 
      type: [Number, String], 
      default: '100%' 
    },
  },
  computed: {
    responsiveStyle() {
      const formatSize = (val) => {
        // 判断是否为纯数字或可以转为数字的字符串（排除 '100%' 这种带百分号的）
        if (typeof val === 'number' || (!isNaN(Number(val)) && val !== '')) {
          let rootFontSize = 16; 
          
          if (typeof window !== 'undefined' && document.documentElement) {
            // 动态读取当前屏幕分辨率下，大屏适配脚本算出的真实 html 根字号
            rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16;
          }
          
          // 如果传的是纯数字，转换为自适应的 rem
          return `${Number(val) / rootFontSize}rem`;
        }
        
        // 🎯 核心逻辑：如果不传参（走默认的 '100%'）或传入类似 '50%'，这里不作任何处理直接返回字符串
        return val;
      };

      return {
        '--svgwidth': formatSize(this.width),
        '--svgheight': formatSize(this.height),
        '--svg-color': this.fill || 'currentColor'
      };
    }
  }
};
